<template>
  <div class="contact-box">
    <div class="contact-main">
      <template v-for="(item, index) in mainList">
        <div class="item" :key="index">
          <div class="title">
            <h3>请填写研究信息{{index+1}}的相关信息</h3>
            <span @click="del(index)" v-if="index > 0">删除</span>
          </div>
          <advanced-form 
          :initFields="JSON.parse(contactFormFieldsJson)" 
          :formData.sync="item" 
          :allDictionary="allDictionary" 
          :customDataList="customDataList" 
          :showLabel="true" 
          :showTitle="false" />
        </div>
      </template>
    </div>
    <div class="buttonBox">
      <van-button type="primary" size="large" @click="addContact">新增</van-button>
      <van-button type="primary" size="large" @click="check">保存修改</van-button>
    </div>
  </div>
</template>

<script>
import {getSchemaDetails,getBranchs ,researchProjectSave,getResearchProjects} from "@/api/dictionary";
import { mapState,mapGetters } from "vuex";
import AdvancedForm from "../../../components/AdvancedForm.vue";
import {Button} from "vant";
export default {
  data() {
    return {
      mainList: [],
      contactFormFieldsJson: "[]",
      customDataList: {},
      branchs: [],
    };
  },
  computed: {
    ...mapState(["userInfo"]),
    ...mapGetters(["allDictionary"])
  },
  components: {
    AdvancedForm,
    [Button.name]: Button
  },
  watch: {
    deep: true,
    userInfo() {
      this.getList();
    }
  },
  mounted() {
      getSchemaDetails({batchType: 3, businessType: 23}).then(resp => {
          this.contactFormFieldsJson = JSON.stringify(resp.result);
      }).catch(() => {
          this.$message.error("获取表单字段信息失败，batchType=3, businessType=11");
      });

    getBranchs().then(res => {
        if (res.success) {
          res.result.forEach(itm => (itm.value = itm.code));
          this.branchs = res.result;
          this.customDataList["recommendUnitId"] = res.result;
        } else {
          this.$message.error(res.message);
        }
      });

      this.getList();
  },
  methods: {
    check() {
 
      for (let i = 0; i < this.mainList.length; i++) {
 

        if (i == this.mainList.length - 1) {
          this.save();
        }
      }
    },
    addContact() {
      this.mainList.push({});
    },
    getList() {
      let params = {
        memberId: this.userInfo.id
      };
      getResearchProjects(params).then(res => {
        if (res.success) {
          this.mainList = res.result.length ? res.result : [{}];
        }
      });
    },
    save() {
      let list = this.mainList;

      let params = {
        memberId: this.userInfo.id,
        contacts: JSON.stringify(list)
      };
      researchProjectSave(params).then(res => {
        this.$message({
          message: "添加成功",
          type: "success"
        });
      });
    },
    del(index) {
      this.mainList.splice(index, 1);
    }
  }
};
</script>

<style scoped lang="less">
.contact-main {
  .item {
    margin-top: 10px;
  }
  .title {
    display: flex;
    height: 50px;
    justify-content: space-between;
    align-items: center;
    h3 {
      font-size: 16px;
      padding-left: 7px;
      border-left: 2px solid #228ccd;
      color:#228ccd
    }
    span {
      margin-right: 10px;
      color: #228ccd;
      cursor: pointer;
    }
  }
  .list-box {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .adv-width {
      width: auto;
      margin-top: 10px;
  }
  .list-item {
    display: flex;
    width: 350px;
    margin-top: 30px;
    align-items: center;
    .label {
      display: block;
      width: 96px;
      font-size: 16px;
      text-align: center;
    }
    .value {
      width: 276px;
    }
  }
}
.buttonBox {
  padding: 20px 0;
  margin-right:-10px;
  display: flex;
  button{
      margin-right:10px
  }
}
</style>


